import css from 'styled-jsx/css';

const staticStyles = css.global`
  .RestartChallengeForm__RefundableFee > span {
    color: #000;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
  }

  .RestartChallengeForm__RefundableFee > div {
    color: #0aa1e2;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 160%;
  }

  .RestartChallengeForm__bottom {
    display: grid;
    row-gap: 8px;
    column-gap: 60px;
    @media only screen and (min-width: 1200px) {
      grid-template-columns: auto 1fr;
      grid-template-rows: auto auto;
    }
  }

  .RestartChallengeForm__bottom > .DivWithDefButton {
    min-width: 200px;
    @media only screen and (min-width: 1200px) {
      grid-column: 2/2;
      grid-row: 1/3;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
`;

export { staticStyles };
